import { FC } from 'react';

import { useWindowSize } from 'shared/hooks/useWindowSize';
import Intro from './Intro';
import { IntroModal } from './IntroModal';
import { SBar } from './style';
import { IIntroBarProps } from './types';

export const IntroBar: FC<IIntroBarProps> = ({
  onChange,
  balance,
  currency,
  showBalance,
}) => {
  const screen = useWindowSize();

  const handleChange = () => {
    onChange(null);
  };

  return screen && screen?.width < 992 ? (
    <IntroModal
      onChange={handleChange}
      balance={balance}
      currency={currency}
      showBalance={showBalance}
      showFlag={false}
    />
  ) : (
    <SBar>
      <Intro
        setIsIntro={handleChange}
        balance={balance}
        currency={currency}
        showBalance={showBalance}
      />
    </SBar>
  );
};
